import * as Yup from 'yup';

export const getValidationSchema = (intl) =>
    Yup.object().shape({
        company: Yup.string().required(intl.formatMessage({ id: 'validation.required' })).nullable(),
        category: Yup.string().required(intl.formatMessage({ id: 'validation.required' })).nullable(),
        name: Yup.string().required(intl.formatMessage({ id: 'validation.required' })).nullable(),
    });

export default getValidationSchema;